<template>
  <Navbar></Navbar>
  <div class="views">
    <router-view/>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";

export default {
  name: 'App',
  components: {
    Navbar
  }
};
</script>

<style>
/* Use lato */
@import url('https://fonts.googleapis.com/css?family=Lato:400,700,900');

body {
  margin: 0;
  padding: 0;
  font-family: 'Lato', sans-serif;
}

.views {
  margin-top: 75px;
}

pre {
  all: initial;
  background-color: unset !important;
}
</style>
